import { getLayer, isStatsigInitialized } from '@eventbrite/statsig';
import classNames from 'classnames';
import React, { useContext } from 'react';
import { LISTING_PAGE_TABS_EXPERIMENT } from '../../constants';
import { EventDescriptionProps } from '../EventDetails/EventDescription/EventDescription';
import { getTabNavigationItems, TAB_NAVIGATION_IDS } from './constants';
import { TabsNavigationContext } from './context';

import './TabsNavigation.scss';

export const TabsNavigation = (eventDescription?: EventDescriptionProps) => {
    const tabsNavigationExperimentValue = getLayer(
        LISTING_PAGE_TABS_EXPERIMENT.layer,
        LISTING_PAGE_TABS_EXPERIMENT.param,
        LISTING_PAGE_TABS_EXPERIMENT.defaultValue,
    );

    const isTabsNavigationExperiment =
        tabsNavigationExperimentValue ===
        LISTING_PAGE_TABS_EXPERIMENT.tabsVariant;

    const { selectedTabId } = useContext(TabsNavigationContext);
    const handleClick = (event: any, id: TAB_NAVIGATION_IDS) => {
        event.preventDefault();
        document
            .getElementById(id)
            ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    if (!isStatsigInitialized() || !isTabsNavigationExperiment) return null;
    const tabNavigationItems = getTabNavigationItems(eventDescription);

    return (
        <div className="tabs-navigation__container">
            <nav className="tabs-navigation__nav">
                <ul className="tabs-navigation">
                    {tabNavigationItems.map(({ label, id }) => (
                        <li
                            key={id}
                            className={classNames('tabs-navigation__item', {
                                'tabs-navigation__item--selected':
                                    selectedTabId === id,
                            })}
                        >
                            <a
                                href={`#${id}`}
                                onClick={(event) => handleClick(event, id)}
                                data-heap-id={label}
                                className="tabs-navigation__item-link eds-text-bm eds-text-weight--heavy"
                                aria-label={`Scroll to ${label}`}
                            >
                                {label}
                            </a>
                        </li>
                    ))}
                </ul>
            </nav>
        </div>
    );
};
